import {useCallback} from "react";

import {GuideStateApi} from "@khan/guide-state";
import type {ChatInputMetadata} from "@khan/guide-types";

import {useInitializeGuide} from "../hooks/use-initialize-guide.ts";
import {useSendChatMessage} from "../hooks/use-send-chat-message.ts";

// A function that will open the chat window, initialize the AI, and send a
// chat message when initialization is complete.
export const useOpenThenSendChatMessageWhenInitialized = (): ((
    message: string,
    metadata: ChatInputMetadata,
) => Promise<void>) => {
    const initializeGuide = useInitializeGuide();
    const sendChatMessage = useSendChatMessage();

    return useCallback(
        (message, metadata): Promise<void> => {
            GuideStateApi.set("open", true);
            // initializeGuide is idempotent so it will resolve if the guide is
            // already initialized or return an existing/new initialization
            // promise.
            return initializeGuide().then(() =>
                sendChatMessage(message, metadata),
            );
        },
        [initializeGuide, sendChatMessage],
    );
};
